import React from 'react';
import {View} from 'react-native';
import {Text} from '../../../../../../shared/components/text';
import {dateFormats} from '../../../../../../shared/constants/date';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {ProfileApplicationsStatus} from '../../../../../../shared/models/profile/applications';
import {hexToRgbA, datePipe} from '../../../../../../shared/pipes';
import {useTheme} from '../../../../../../shared/theme';
import {capitalize} from '../../../../../../shared/utils/text';
import {Props} from './model';

export default ({application, style}: Props) => {
  const _theme = useTheme();
  const styles = useStyles(({theme}) => ({
    container: {
      backgroundColor: theme.color.primaryNonGreyBackground,
      borderRadius: 14,
      width: '100%',
    },
    header: {
      minHeight: 45,
      paddingHorizontal: 20,
      paddingVertical: 10,
      position: 'relative',
    },
    body: {
      borderBottomLeftRadius: 14,
      borderBottomRightRadius: 14,
      backgroundColor: hexToRgbA(theme.applications.mobileListItemBodyBg, 0.15),
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 20,
      paddingVertical: 10,
    },
    status: {
      width: 10,
      height: 10,
      position: 'absolute',
      right: 8,
      top: 8,
    },
    textNormal: {
      ...theme.fonts.body,
    },
    textActive: {
      ...theme.fonts.action,
    },
    dateWrapper: {
      width: 128,
    },
    dateText: {
      ...theme.fonts.label,
      color: theme.color.labelText,
    },
    statusWrapper: {
      flexGrow: 1,
    },
    statusText: {
      ...theme.fonts.bodySmallLight,
      textAlign: 'right',
    },
  }));
  return (
    <View style={[styles.container, style]}>
      <View style={styles.header}>
        <Text style={styles.textNormal}>{`${capitalize(application.typeApplicationName)}${
          application.isChildApplication ? ' ребенку (законный представитель)' : ''
        }`}</Text>
        {/* <View style={styles.status}>
          <StatusIndicator active={!application.isRead} />
        </View> */}
      </View>
      <View style={styles.body}>
        <View style={styles.dateWrapper}>
          <Text style={styles.dateText}>{datePipe(application.dateTimeFiling, dateFormats.fullDateWithTime)}</Text>
        </View>
        <View style={styles.statusWrapper}>
          <Text
            style={[
              styles.statusText,
              {
                color:
                  _theme.applications.statusColors[
                    (application.statusId as ProfileApplicationsStatus) || ProfileApplicationsStatus.accepted
                  ],
              },
            ]}>
            {application.statusName}
          </Text>
        </View>
      </View>
    </View>
  );
};
